import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { EnquiryContext } from "venuescanner-js/react/components/Inbox/context/EnquiryContext";
import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import flagService, { flag } from "venuescanner-js/services/models/userFlags";

import Match from "venuescanner-js/react/components/Inbox/components/Matches/Match";
import MatchInstructions from "venuescanner-js/react/components/Inbox/components/Matches/MatchInstructions";
import MatchAwaitingLeads from "venuescanner-js/react/components/Inbox/components/Matches/MatchAwaitingLeads";
import MatchesOnboardingPopup from "venuescanner-js/react/components/Inbox/components/Matches/MatchesOnboardingPopup";
import { Button } from "@mui/material";

const Matches = ({ skipOnBoarding }) => {
  const { organiserLeads, indicators } = useContext(EnquiryContext);
  const { activeMatchEvent, setActiveMatchEvent, isMobileDevice } =
    useContext(ViewContext);
  const [onboardedFlag, setOnboardedFlag] = useState({});
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [searchUrl, setSearchUrl] = useState("london");

  useEffect(
    () =>
      flagService.fetch().then((res) => {
        setOnboardedFlag(res);

        if (res[flag.MATCHESINTRO] || skipOnBoarding) {
          setShowOnboarding(false);
          return;
        }

        setShowOnboarding(true && isMobileDevice);
      }),
    [skipOnBoarding, onboardedFlag, isMobileDevice]
  );

  const closeOnboarding = () => {
    if (!onboardedFlag[flag.MATCHESINTRO])
      onboardedFlag[flag.MATCHESINTRO] = true;
    setShowOnboarding(false);
  };

  useEffect(() => {
    if (!activeMatchEvent) setActiveMatchEvent(organiserLeads[0]);
  }, [organiserLeads]);

  useEffect(() => {
    if (activeMatchEvent?.leads[0]) {
      setSearchUrl(activeMatchEvent.leads[0].toJSON().venue.location.slug);
    }
  }, [activeMatchEvent]);

  return organiserLeads && organiserLeads?.length > 0 ? (
    <div className="matches inbox__section">
      {showOnboarding && (
        <MatchesOnboardingPopup handleClose={() => closeOnboarding()} />
      )}
      <div className="matches__header">
        {activeMatchEvent?.leads?.length > 1 ? (
          <h3 className="matches__title">
            The following venues are available to host your event
          </h3>
        ) : (
          <h3 className="matches__title">
            The following venue is available to host your event
          </h3>
        )}
        {isMobileDevice && (
          <div className="matches__settings">
            <button
              className="matches__settings__more-info p"
              onClick={() => setShowOnboarding(true)}
            ></button>
          </div>
        )}
      </div>
      {activeMatchEvent?.leads?.length ? (
        <div className="matches__list">
          {activeMatchEvent.leads.map((match) => (
            <Match key={match.data()._id} match={match} />
          ))}
        </div>
      ) : null}
      <div className="matches__list__footer">
        <p className="matches__list__footer__title">
          Are you looking for something different?
        </p>
        <p className="matches__list__footer__copy">
          Choose from over 20,000 venues and find the perfect place to host your
          event
        </p>
        <Button
          sx={{ marginTop: "32px", marginBottom: "132px" }}
          size="large"
          variant="contained"
          href={`/search?location=${searchUrl}`}
          target="_blank"
        >
          Explore more venues
        </Button>
      </div>
    </div>
  ) : (
    <div className="matches matches__constrain-overflow inbox__section">
      {indicators?.matches?.received ? (
        <MatchAwaitingLeads />
      ) : (
        <MatchInstructions />
      )}
    </div>
  );
};

Matches.propTypes = {
  skipOnBoarding: PropTypes.bool,
};

export default Matches;
